import React, { useEffect } from 'react';
import { useDispatch, useSelector } from 'react-redux';
import { useHistory } from 'react-router';
import ReincorporationProgressView from './ReincorporationProgressView';
import { Creators as activatePaymentActions } from '../../../../../../../domain/useCases/procedures/reincorporation/activatePaymentReincorporationUseCase';
import { Creators as enrolmentTurnActions } from '../../../../../../../domain/useCases/getProfileTurnByPeriod';
import routes from '../../../../../../components/Routes/routingMap';

const ReincorporationProgressViewController = () => {
  const history = useHistory();
  const dispatch = useDispatch();
  // selectors
  const {
    procedure,
    request,
    isLoading: isLoadingDetail
  } = useSelector((state: any) => state.procedureStudentStatus);

  useEffect(() => {
    if (!isLoadingDetail && !procedure) {
      history.push('/tramites');
    }
  }, [isLoadingDetail, procedure]);

  const {
    isLoading: isLoadingActivatePayment,
    isSuccess: isSuccessActivatePayment
  } = useSelector((state: any) => state.activatePaymentReincorporation);

  const { data: dataProfileTurn } = useSelector(
    (state: any) => state.getEnrolmentAppByPeriod
  );
  // handlers
  const handlerBackButton = () => {
    history.push('/tramites');
  };

  const handlerActivatePayment = () => {
    dispatch(
      activatePaymentActions.activatePayment(
        request.procedureId,
        request.id,
        '',
        ''
      )
    );
  };

  useEffect(() => {
    if (request) {
      if (request.status.status === 'FINALIZADO') {
        const { periodReincorporated } = procedure.detail;
        dispatch(
          enrolmentTurnActions.getProfileTurnByPeriod(periodReincorporated)
        );
      }
      if (request?.status?.name === 'Procede') {
        history.push(
          `${
            routes.student.procedures.categories.requests.reincorporation
              .progress
          }${'?status=finalizado'}`
        );
      }
    }
  }, [request]);

  return (
    <ReincorporationProgressView
      procedure={procedure}
      request={request}
      isLoadingDetail={isLoadingDetail}
      onBackButton={handlerBackButton}
      handlerActivatePayment={handlerActivatePayment}
      isLoadingActivatePayment={isLoadingActivatePayment}
      isSuccessActivatePayment={isSuccessActivatePayment}
      enrolmentTurn={{
        date: dataProfileTurn?.textDate,
        hour: dataProfileTurn?.textHour
      }}
    />
  );
};

export default ReincorporationProgressViewController;
